<template lang="pug">
  div(:class="$style.journalNew")
    el-button(
      :class="$style.filterButtonShow"
      @click="filtersIsShow = true"
    )
      v-icon(name="filterIcon" :size="20" )

    transition(name="slide-fade-top")
      div(:class="[$style.filtersWrap, {[$style['--is-show']]: filtersIsShow}]")
        el-button(
          :class="$style.filterButtonClose"
          @click="filtersIsShow = false"
        )
          v-icon(name="close" :size="20" )

        journalFilters(
          :class="$style.journalFilters"
          :current-group.sync="currentGroup"
          :current-discipline.sync="currentDiscipline"
          :current-semester.sync="currentSemester"
          :current-year.sync="currentYear"
          :semesters="semesters"
          :groups="groups"
          :hidden-groups.sync="hiddenGroups"
          :periods-by-year="periodsByYear"
          :periods-years="periods.years"
          :disciplines="disciplines"
          :is-load="flags.isLoad"
        )

        el-button(
          :class="$style.homeworkBtn"
          @click="homeworkIsShow = !homeworkIsShow"
        ) {{ homeworkIsShow ? 'Журнал' : 'Домашнее задание' }}

    journalHomework(
      v-if="homeworkIsShow && homeworks.length"
      :homeworks="homeworks"
      :current-discipline="currentDiscipline"
      @update-homework="updateHomeworks"
    )

    journalTable(
      v-if="!homeworkIsShow && formattedStudents.length"
      :class="$style.journalTable"
      :students="formattedStudents"
      :assessments="assessments"
      :dates="dates"
      :homeworks="homeworks"
      :selected-date.sync="selectedDate"
      :homework-modal-is-show="homeworkModalIsShow"
      @update="updateAssessments"
    )

    p(v-if="emptyMessageIsShow" :class="$style.notice") Список пуст
</template>

<script>
  import journalFilters from '@/components/pages/journalNew/journalFilters';
  import journalTable from '@/components/pages/journalNew/journalTable'
  import journalHomework from '@/components/pages/journalNew/journalHomework';
  import snakeizeKeys from '@/utils/snakeizeKeys';
  import camelizeKeys from '@/utils/camelizeKeys';

  export default {
    name: "JornalNew",

    components: {
      journalHomework,
      journalFilters,
      journalTable
    },

    data() {
      return {
        homeworkModalIsShow: false,
        homeworkIsShow: false,
        filtersIsShow: false,
        currentGroup: null,
        currentDiscipline: null,
        currentSemester: null,
        currentYear: null,
        semesters: [],
        selectedDate: null,
        assessments: [],
        students: [],
        groups: [],
        hiddenGroups: [],
        dates: [],
        periods: {
          years: [],
          all: {}
        },
        homeworks: [],
        disciplines: [],
        query: {
          groupId: null,
          date: null,
          disciplineId: null
        },
        flags: {
          isInit: false,
          isLoad: false,
        }
      }
    },

    computed: {
      emptyMessageIsShow() {
        return this.homeworkIsShow ? !this.homeworks.length : !this.formattedStudents.length;
      },

      filtersIsReady() {
        return this.currentSemester && this.currentDiscipline && this.currentGroup;
      },

      periodsByYear() {
        return this.currentYear ? this.periods.all[this.currentYear] : [];
      },

      formattedStudents() {
        return this.students.map(student => {
          const assessments = student.assessments.map(assessment => ({
            ...assessment,
            assessment: this.assessments.find(a => a.id === +assessment.assessmentCode)?.name || ''
          }))
          return {
            ...student,
            assessments
          }
        });
      },
    },

    watch: {
      currentYear() {
        this.students = [];

        if (this.flags.isInit) {
          this.currentSemester = null;
        }
      },

      async currentSemester(newValue) {
        this.students = [];

        if (newValue) {
          !this.groups.length && await this.getGroups();

          if (!this.flags.isInit) {
            this.currentGroup = this.query.groupId ? this.query.groupId : this.getFirstVisibleGroup();
          } else {
            this.checkExistGroup();
            this.checkExistDiscipline();
          }
        } else {
          this.currentGroup = null;
          this.currentDiscipline = null;
        }

        this.filtersIsReady && this.runFilter();
      },

      async currentGroup(newValue, oldValue) {
        this.students = [];

        // Если группа сброшена после скрытия
        if (!newValue && oldValue) {
          this.currentDiscipline = null;
          this.$notify.info({
            message: 'Выберите группу для продолжения работы',
            duration: 2000
          });
          return;
        }

        newValue && await this.getDisciplines(newValue);

        this.checkExistDiscipline();

        if (!this.flags.isInit) {
          this.currentDiscipline = this.query.disciplineId ? this.query.disciplineId : this.disciplines[0]?.disciplineId || null;
        } else {
          this.filtersIsReady && this.runFilter();
        }
      },

      async currentDiscipline(newValue) {
        this.students = [];
        if (newValue) {
          await this.runFilter();
        }

        if (!this.flags.isInit) {
          this.flags.isInit = true;
        }
      },
    },

    async created() {
      await this.init();
    },

    methods: {
      async updateHomeworks() {
        this.homeworks = await this.fetchHomeworks();
      },

      checkExistDiscipline() {
        const disciplineExistInNewList = this.disciplines.find(discipline => discipline.disciplineId === this.currentDiscipline);

        if (!disciplineExistInNewList) {
          this.currentDiscipline = null;
        }
      },

      checkExistGroup() {
        const groupExistInList = this.groups.find(group => group.groupId === this.currentGroup);
        if (!groupExistInList) {
          this.currentGroup = null;
        }
      },

      setFilterPresets() {
        this.currentYear = this.getCurrentYear();
        this.currentSemester = this.getCurrentSemester();
      },

      getCurrentSemester() {
        const currentYear = this.query.date ? this.$moment(this.query.date, 'YYYY-MM-DD').year() : this.$moment().year();
        const intervals = {
          1: {
            start: `20.08.${currentYear}`,
            end: `31.12.${currentYear}`
          },
          2: {
            start: `01.01.${currentYear}`,
            end: `19.08.${currentYear}`
          }
        };

        const actualDate = this.query.date ? this.$moment(this.query.date, 'YYYY-MM-DD') : this.$moment();
        const currentSemester = Object.keys(intervals).reduce((acc, key) => {
          if (actualDate.diff(this.$moment(intervals[key].start, 'DD.MM.YYYY'), 'days') >= 0 && actualDate.diff(this.$moment(intervals[key].end, 'DD.MM.YYYY'), 'days') <= 0) {
             acc = key;
          }

          return acc;
        }, null);

        return this.periodsByYear[currentSemester - 1]?.periodId || null;
      },

      getCurrentYear() {
        const actualDate = this.query.date ? this.$moment(this.query.date, 'YYYY-MM-DD') : this.$moment();
        const calendarYear = actualDate.year();
        const month = actualDate.month() + 1; // moment months are 0-indexed
        const day = actualDate.date();

        // Учебный год начинается 20 августа
        // Если мы до 20 августа — это 2 семестр предыдущего учебного года
        // Если после 20 августа — это 1 семестр нового учебного года
        const isSecondSemester = month < 8 || (month === 8 && day < 20);
        const academicYear = isSecondSemester ? calendarYear - 1 : calendarYear;

        return this.periods.years.find(year => {
          const splittedValue = year.split('/');
          return +splittedValue[0] === academicYear;
        }) || null;
      },

      async updateAssessments({ sIdx, dateId, assessmentCode, dateLesson }) {
        try {
          const currentAssesmentIndex = this.students[sIdx].assessments.findIndex(el => el.dateLesson === dateLesson)

          if (!!~currentAssesmentIndex) {
            this.students[sIdx].assessments[currentAssesmentIndex].assessmentCode = assessmentCode;
          } else {
            this.students[sIdx].assessments.push({
              assessmentCode,
              dateLesson,
            })
          }

          const schema = {
            lessonDatetime: dateLesson,
            subjectCode: this.currentDiscipline,
            marks: this.students.map(student => {
              const assessment = student.assessments.find(a => a.dateLesson === dateLesson);
              return {
                periodId: this.currentSemester,
                studentCode: student.id,
                groupCode: this.currentGroup,
                mark: assessment ? assessment.assessmentCode : 0
              }
            })
          }

          const { data: { status, messages } } = await this.axios.patch('/api/ejournal/setmarks', schema);

          if (!status) {
            this.$notify.error({
              message: messages,
              duration: 3000
            });
          }
        } catch (e) {
          console.warn('Failed fetch update assessments [journalNew/updateAssessments]', e);
        }
      },

      async runFilter() {
        const { assessments, students } = await this.fetchAssessments();
        const homeworks = await this.fetchHomeworks();

        this.homeworks = homeworks;
        this.dates = homeworks.map(lesson => `${lesson.dateLesson} ${lesson.timeLesson}`);
        this.students = students;
        this.assessments = assessments;

        if (!students.length) {
          this.$notify({
            message: 'Список студентов пуст',
            duration: 2000
          });

          this.students = []
        }

        if (!assessments.length) {
          this.$notify({
            message: 'Список оценок пуст',
            duration: 2000
          });
        }
      },

      async init() {
        this.query = camelizeKeys(this.$route.query);
        await Promise.all([
          this.getPeriods(),
          this.loadHiddenGroups()
        ]);
        this.setFilterPresets();
      },

      async loadHiddenGroups() {
        try {
          const response = await this.axios.get('/api/ejournal/hidden-groups');
          if (response.data && response.data.status) {
            const hiddenGroups = camelizeKeys(response.data.data).hiddenGroups || [];
            this.hiddenGroups = Array.isArray(hiddenGroups) ? hiddenGroups : [];
          }
        } catch (e) {
          this.hiddenGroups = [];
        }
      },

      getFirstVisibleGroup() {
        const visibleGroup = this.groups.find(group => !this.hiddenGroups.includes(group.groupId));
        return visibleGroup?.groupId || null;
      },

      async getPeriods() {
        const periods = await this.fetchPeriods();

        this.periods.years = Object.keys(periods);
        this.periods.all = Object.keys(periods).reduce((acc, key) => {
          acc[key] = camelizeKeys(periods[key]);
          return acc;
        }, {});
      },

      async getGroups() {
        const groups = await this.fetchGroups();
        this.groups = camelizeKeys(groups);
      },

      async getDisciplines(groupId) {
        const disciplines = await this.fetchDisciplines(groupId);
        this.disciplines = camelizeKeys(disciplines);
      },

      async fetchAssessments() {
        try {
          this.flags.isLoad = true;
          const params = snakeizeKeys({
            groupId: this.currentGroup,
            disciplineId: this.currentDiscipline,
            periodId: this.currentSemester
          });

          const response = await this.axios.get('/api/ejournal/assessment', { params } );
          const isSuccess = response.status === 200;
          const { data: students, assessments, dates } = camelizeKeys(response.data);

          return {
            students: isSuccess && students ? students : [],
            assessments: isSuccess && assessments ? assessments : [],
            dates,
          }
        } catch (e) {
          console.warn('Failed fetch groups [journalNew/fetchAssessments]', e);
          return {
            students: [],
            assessments: []
          }
        } finally {
          this.flags.isLoad = false;
        }
      },

      async fetchHomeworks() {
        try {
          const params = snakeizeKeys({
            groupId: this.currentGroup,
            disciplineId: this.currentDiscipline,
            periodId: this.currentSemester
          });

          const { data } = await this.axios.get('/api/ejournal/lessons', { params });

          return camelizeKeys(data.data);
        } catch (e) {
          console.warn('Fetch is failed', e)
        }
      },

      async fetchDisciplines(groupId)  {
        try {
          this.flags.isLoad = true;
          const params = snakeizeKeys({ groupId });
          const { data: { data: currentData }, status } = await this.axios.get('/api/ejournal/disciplines', { params });

          return status === 200 ? currentData : [];
        } catch (e) {
          console.warn('Failed fetch groups [journalNew/fetchDisciplines]', e);
        } finally {
          this.flags.isLoad = false;
        }
      },

      async fetchGroups() {
        try {
          this.flags.isLoad = true;
          const { data: { data: currentStatus }, status } = await this.axios.get('/api/ejournal/groups');
          return status === 200 ? currentStatus : [];
        } catch (e) {
          console.warn('Failed fetch groups [journalNew/fetchGroups]', e);
        } finally {
          this.flags.isLoad = false;
        }
      },

      async fetchPeriods() {
        try {
          this.flags.isLoad = true;
          const { data: { data: currentData }, status } = await this.axios.get('/api/ejournal/periods');
          return status === 200 ? currentData : null;
        } catch (e) {
          console.warn('Failed fetch periods [journalNew/fetchPeriods]', e);
        } finally {
          this.flags.isLoad = false;
        }
      },
    }
  }
</script>

<style lang="scss" module>
  .journalNew {
    overflow: hidden;
    display: grid;
    grid-template-rows: auto 1fr;
    max-height: calc(100dvh - 40px);

    @media (max-width: 800px) {
      max-height: calc(100dvh - 80px);
    }

    .filterButtonShow {
      display: none;
      margin-bottom: 30px;

      @include breakPoints(md) {
        display: block;
      }
    }

    .filterButtonClose {
      display: none;
      margin-bottom: 50px;

      @include breakPoints(md) {
        display: block;
      }
    }

    .homeworkBtn {
      margin-left: auto;
      margin-bottom: 30px;

      @include breakPoints(md) {
        display: none;
      }
    }
  }

  .filterButton {
    display: none;

    @include breakPoints(md) {
      display: block;
    }
  }

  .filtersWrap {
    display: flex;

    @include breakPoints(md) {
      flex-direction: column;
      position: fixed;
      left: 0;
      top: 50px;
      transform: translateX(-100%);
      transition-duration: .3s;
      transition-property: transform;
      z-index: 10;
      width: 100%;
      height: calc(100% - 50px);
      background-color: $basic-white;
      padding: 20px;
    }

    &.--is-show {
      @include breakPoints(md) {
        transform: translateX(0);
      }
    }
  }

  .journalFilters {
    margin-bottom: 30px;
  }

  .notice {
    text-align: center;
    color: $regular-text-clr;
  }
</style>
